import { CLEAR_SNIPPETS, UPDATE_SNIPPETS } from "../reducers/actiontypes";

export let clearSnippets = function() {
	return {
		type: CLEAR_SNIPPETS
	};
}

export let updateSnippets = function(snippets) {
	return {
		type: UPDATE_SNIPPETS,
		snippets: snippets
	};
}

export let fetchSnippets = function() {
	return function(dispatch, getState) {
		dispatch(clearSnippets());

		window.getInstances(function(err, data){
			if (!err) {
				dispatch(updateSnippets(data));
			}
		});
	};
};